import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	topSection: {
		display    : "flex",
		alignItems : "center"
	},
	img: {
		height : "100%",
		width  : "100%",
		border : "1px solid #dddddd",
		...theme.other.rooterAvatars.borderRadius
	},
	svgIcon: {
		...theme.other.svgIcons.size30
	},
	topPointsPointsText: {
		textAlign               : "center",
		marginTop               : "0.5rem",
		"& .MuiTypography-root" : {
			whiteSpace   : "nowrap",
			overflow     : "hidden",
			textOverflow : "ellipsis",
			maxWidth     : "50px"
		}
	},
	topPointsAvatarContainer: {
		flex           : "1",
		display        : "flex",
		justifyContent : "center"
	},
	topPointsAvatar: {
		...theme.other.rooterAvatars.size40,
		position: "relative"
	},
	topPointsContainer: {
		padding      : "1rem",
		marginBottom : "0.5rem",
		background   :
			props?.fanRank === 1
				? "linear-gradient(to top, #de8700, #f7a628)"
				: props?.fanRank === 2
					? "linear-gradient(to top, #adadad, #d6d6d6)"
					: "linear-gradient(to top, #d15900, #fd842a)",
		borderRadius: "5px"
	},
	coinsContainer: {
		padding        : "0 0.5rem",
		borderRadius   : "5px",
		textAlign      : "center",
		background     : "#a66604",
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center"
	},
	coinText: {
		color      : "#fcc62d",
		fontWeight : "500"
	},
	rooterCoinIcon: {
		...theme.other.svgIcons.size10,
		marginLeft: "0.2rem"
	},
	topPointsMedal: {
		position : "absolute",
		left     : "-10px",
		bottom   : "-10px"
	}
} ) );